import React from "react";
import { Modal } from "react-bootstrap";
import { FaIcon } from "../../../lib/FaIcon";
import { _t } from "app/i18n/i18n";

export const Title = ({ title, icon, isClosable = false }) => (
  <Modal.Header closeButton={isClosable}>
    <Modal.Title>
      {icon && <FaIcon icon={icon} className="mr-2" />}
      {_t(title)}
    </Modal.Title>
  </Modal.Header>
);
